import { useNavigate } from "react-router-dom";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { CreateScheduleSlotCommand, ScheduleClient } from "../../web-api-client";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { appConfig } from "../../appconfig";

export function useCreateSchedule() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (body: CreateScheduleSlotCommand) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });

      return client.createScheduleSlot(body);
    },
    onSuccess: () => {
      // Sau khi tạo refetch toàn bộ schedule
      queryClient.invalidateQueries({ queryKey: ["schedules"] });
    },
  });
}
